import React, { Component } from "react";

import Menu from "./menu";

import "./css/off-balance.css";

class PreventDefault extends Component {
  render() {
    return (
      <div className="off-balance-page">
        <Menu type="talks" />
        <div className="section-wrapper conclusion">
          <div className="section context">
            <div className="column">
              <h1>Off Balance</h1>
              <h2>Interactive Storytelling with React</h2>
              <p>
                <a href="https://2019.reactrally.com" target="_blank" rel="noopener noreferrer">
                  React Rally
                </a>{" "}
                August 22, 2019
              </p>
              <h3>Abstract</h3>
              <p>
                In this talk we’ll hold a technical retrospective of an animation heavy interactive experience built
                with React. Through this lens we’ll discuss shape generation, orchestration and dynamic interpolation
                strategies to bring a design to life. Along the way we’ll cover performance considerations and lessons
                learned.
              </p>
            </div>
            <div className="column resources">
              <h3>Resources</h3>
              <div className="resources">
                <ul>
                  <li>
                    <a
                      href="https://www.are.na/mihai-cernusca/personal-off-balance-interactive-storytelling-with-react"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Shownotes (are.na)
                    </a>
                  </li>
                  <li>
                    <a href="https://codesandbox.io/s/23y323m8pj" target="_blank" rel="noopener noreferrer">
                      Example 1: Shape Generation (codesandbox.io)
                    </a>
                  </li>
                  <li>
                    <a href="https://codesandbox.io/s/l5mmo0kp7m" target="_blank" rel="noopener noreferrer">
                      Example 2: Dynamic Interpolation (codesandbox.io)
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://codesandbox.io/s/obrr-orchestration-n9fnc"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Example 3: Orchestration (codesandbox.io)
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="column">
              <div className="talk-video">
                <figure className="youtube">
                  <iframe
                    width="560"
                    height="315"
                    title="Off Balance - Interactive Storytelling with React"
                    src="https://www.youtube.com/embed/CqQX_pIAJug?t=7657&rel=0&amp;showinfo=0"
                    frameBorder="0"
                    allowFullScreen
                  />
                </figure>
              </div>
              <figure className="swipe">
                <iframe
                  title="Off Balance - Interactive Storytelling with React"
                  src="https://off-balance-react-rally.netlify.app"
                  allowFullScreen
                />
              </figure>
              <p className="caption">
                Use arrow keys to navigate.{" "}
                <a href="https://off-balance-react-rally.netlify.app" target="_blank" rel="noopener noreferrer">
                  Open in a new window
                </a>{" "}
                for a better experience.
              </p>
            </div>
            <div className="column">
              <p>
                <a href="#top" className="to-top">
                  Back to top
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PreventDefault;



// WEBPACK FOOTER //
// ./src/off-balance.js